import store from 'store'
import expirePlugin from 'store/plugins/expire'

store.addPlugin(expirePlugin)

export function save(key, data, duration = 1000 * 60 * 60 * 24 * 1) {
  store.set(key, data, new Date().getTime() + duration)
}

export function load(key) {
  return store.get(key)
}

export function remove(key) {
  store.remove(key)
}

export function clearAll() {
  store.clearAll()
}



// WEBPACK FOOTER //
// ../source/state/persist.js